import { sellersWithPhonesSelector } from './sellersSelector';
import { IApplicationState } from '../types/redux';

export function isLeadFactorySelector(state: IApplicationState) {
  return sellersWithPhonesSelector(state).find(seller => seller.isLeadFactory);
}
